import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import HttpUtility from '../../utilities/HttpUtility';
import NationalModel from '../_model/nationalModel';
import EffectUtility from '../../utilities/EffectUtility';

export const commonEffect = {
  nationality,
  currency,
  country,
  getOrganization,
  getSource,
  getPurpose,
  getOrgBranch,
  getCustDetailsByCode,
  services,
  getAgentDetails,
  serviceProvider,
  typeDetails,
  requestError,
  getCountries,
  checkOTPValidity,
};
async function serviceProvider(payload) {
  const endpoint = environment.api.getServiceProvider.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}
async function nationality() {
  const endpoint = environment.api.nationality.replace();
  const response = await HttpUtility.get(endpoint);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function currency() {
  const endpoint = environment.api.currency.replace();
  const response = await HttpUtility.get(endpoint);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}
async function services(payload) {
  const endpoint = environment.api.services.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}
async function typeDetails() {
  const endpoint = environment.api.typeDetails.replace();
  const response = await HttpUtility.get(endpoint);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function getCountries() {
  const endpoint = environment.api.country.replace();
  const response = await HttpUtility.get(endpoint);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function country() {
  const endpoint = environment.api.country.replace();
  const response = await HttpUtility.get(endpoint);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
  //  return response.data.map((data) => new NationalModel(data));
}

async function getOrganization(payload) {
  const endpoint = environment.api.getOrganization.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function getOrgBranch(payload) {
  const endpoint = environment.api.getOrgBranch.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function getSource(payload) {
  const endpoint = environment.api.getSource.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function getPurpose(payload) {
  const endpoint = environment.api.getPurpose.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function getCustDetailsByCode(payload) {
  const endpoint = environment.api.getCustDetailsByCode.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}
async function getAgentDetails(payload) {
  const endpoint = environment.api.getAgentDetails.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

async function checkOTPValidity(payload) {
  const endpoint = environment.api.checkOTPValidity.replace();
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

/**
 * This is only to trigger an error api response so we can use it for an example in the AboutPage
 */
async function requestError() {
  const endpoint = environment.api.errorExample;
  const response = await HttpUtility.get(endpoint);

  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response.data;
}
